import { CHART_COLORS } from '../../config/constants';

// Slim 100%-stacked share bar (Hynex "spending limits" style).
// data: [{ name, total }]. onSegmentClick(name) optional.
export function ShareBar({ data, onSegmentClick }) {
  const total = (data || []).reduce((s, d) => s + (Number(d.total) || 0), 0) || 1;
  return (
    <div className="flex h-3 w-full overflow-hidden rounded-full bg-slate-100 dark:bg-white/10">
      {(data || []).map((d, i) => {
        const pct = (Number(d.total) || 0) / total * 100;
        if (pct <= 0) return null;
        const color = CHART_COLORS[i % CHART_COLORS.length];
        return (
          <button
            key={d.name}
            type="button"
            title={`${d.name} — ${pct.toFixed(1)}%`}
            onClick={onSegmentClick ? () => onSegmentClick(d.name) : undefined}
            className="h-full transition-opacity hover:opacity-80"
            style={{ width: `${pct}%`, background: color, cursor: onSegmentClick ? 'pointer' : 'default' }}
          />
        );
      })}
    </div>
  );
}
